/**
 * Company-profile enums — the WIRE CONTRACT with the backend
 * (`Continity.Domains.TenantManagement.Constants.{BusinessType,Industry,EmployeeCount}`).
 *
 * BACKEND COMPATIBILITY: camelCase strings; the API serializes the C# PascalCase members to
 * camelCase, e.g. `BusinessType.SoleProprietorship` → `"soleProprietorship"`.
 *
 * These live in the shared library — NOT in one app — because both the main portal and the
 * Phoenix portal edit the same company profile against the same endpoint. A per-app copy is
 * exactly the drift this repo already paid for once (see the D-22 note in
 * {@link ./company-profile-labels}).
 *
 * NOTE: `BcmMaturityLevel` deliberately stays in the main portal — it is BCM domain semantics
 * (BSI 200-4 maturity stage) that the Phoenix portal neither shows nor writes.
 */

/** Legal form of the organization. */
export enum BusinessType {
  Corporation = 'corporation',
  LLC = 'llc',
  Partnership = 'partnership',
  SoleProprietorship = 'soleProprietorship',
  NonProfit = 'nonProfit',
  Government = 'government',
  Other = 'other',
}

/** Industry sector of the organization. */
export enum Industry {
  Technology = 'technology',
  Healthcare = 'healthcare',
  Finance = 'finance',
  Manufacturing = 'manufacturing',
  Retail = 'retail',
  Education = 'education',
  Energy = 'energy',
  Transportation = 'transportation',
  RealEstate = 'realEstate',
  Hospitality = 'hospitality',
  Agriculture = 'agriculture',
  Construction = 'construction',
  Telecommunications = 'telecommunications',
  Media = 'media',
  Professional = 'professional',
  Government = 'government',
  NonProfit = 'nonProfit',
  Other = 'other',
}

/** Employee-count bracket of the organization. */
export enum EmployeeCount {
  Range1To10 = 'range1To10',
  Range11To50 = 'range11To50',
  Range51To200 = 'range51To200',
  Range201To500 = 'range201To500',
  Range501To1000 = 'range501To1000',
  Range1001To5000 = 'range1001To5000',
  RangeOver5000 = 'rangeOver5000',
}
